import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import publicAPIServices from '../../../services/publicAPIServices';

const initialState = {
  data: [],
  loading: false,
  error: false,
  success: false,
  message: ''
};

//fetch all data

export const fetchRoomsCatsAllData = createAsyncThunk('roomCatsAll/fetch', async (url, thunkAPI) => {
  try {
    return await publicAPIServices.fetchData(url);
  } catch (error) {
    const message =
      (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const roomCatsAllSlice = createSlice({
  name: 'roomCatsAll',
  initialState,
  reducers: {
    reset: (state) => {
      state.loading = false;
      state.success = false;
      state.error = false;
      state.message = '';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomsCatsAllData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoomsCatsAllData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(fetchRoomsCatsAllData.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.message = action.payload;
        state.data = null;
      });
  }
});

export const { reset } = roomCatsAllSlice.actions;
export default roomCatsAllSlice.reducer;
